// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailContainer {
  margin-top: 100px;
  /* height: 400px; */
  background-color: #eef1ef;
}

.serviceImage {
  height: 300px;
  width: 250px;
  object-fit: cover;
}

.serviceDetailContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

.serviceHeadingContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}

.serviceHeadingBox {
  height: 12px;
  width: 12px;
  background-color: #2e8b57;
}

.serviceHeading {
  font-size: 0.875rem;
  font-style: normal;
  font-family: Poppins;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2e8b57;
}

.serviceDetailsText {
  font-size: 1.125rem;
  font-style: normal;
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0px;
  text-transform: none;
  color: #595959;
}

.serviceContactContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 200px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #2e8b57;
}

.serviceContactBtn {
  width: 200px;
  height: 60px;
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font: 14px;
  font-weight: 600;
  border-radius: 2px;
}

.serviceContactBtn:hover {
  background-color: #081d11;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/general/serviceDetail/ServiceDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".detailContainer {\n  margin-top: 100px;\n  /* height: 400px; */\n  background-color: #eef1ef;\n}\n\n.serviceImage {\n  height: 300px;\n  width: 250px;\n  object-fit: cover;\n}\n\n.serviceDetailContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n}\n\n.serviceHeadingContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 5px;\n}\n\n.serviceHeadingBox {\n  height: 12px;\n  width: 12px;\n  background-color: #2e8b57;\n}\n\n.serviceHeading {\n  font-size: 0.875rem;\n  font-style: normal;\n  font-family: Poppins;\n  font-weight: 600;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #2e8b57;\n}\n\n.serviceDetailsText {\n  font-size: 1.125rem;\n  font-style: normal;\n  font-family: Poppins;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 0px;\n  text-transform: none;\n  color: #595959;\n}\n\n.serviceContactContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 200px;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  background-color: #2e8b57;\n}\n\n.serviceContactBtn {\n  width: 200px;\n  height: 60px;\n  border: 2px solid white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font: 14px;\n  font-weight: 600;\n  border-radius: 2px;\n}\n\n.serviceContactBtn:hover {\n  background-color: #081d11;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
